import React, { useContext, type JSX } from 'react';
import useHandledQuery from '../../../../../../../../../../Components/QueryComponents/HandledQuery/HandledQueryHook';
import query from './EkonomiskAnalysGrundurvalQuery.gql';
import {
  EkonomiskAnalysGrundurvalQuery as IData,
  EkonomiskAnalysGrundurvalQueryVariables as IVariables,
} from './_QueryTypes/EkonomiskAnalysGrundurvalQuery';
import { ActiveDatabaseContext } from '../../../../../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { IGrundurval } from '../../../../../EkonomiskAnalysPage';

interface IProps {
  children: (grundurval: IGrundurval[]) => JSX.Element;
}

const STANDARD_GRUNDURVAL_VISIBILITY = '5';

const EkonomiskAnalysGrundurvalQuery: React.FC<IProps> = props => {
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const queryResult = useHandledQuery<IData, IVariables>(query, {
    variables: { dbName: activeDatabase ? activeDatabase : '' },
  });

  if (!queryResult.data) {
    return queryResult.renderComponent;
  }
  if (!queryResult.data.ek_grundurval) {
    return null;
  }
  return props.children(
    queryResult.data.ek_grundurval.reduce<IGrundurval[]>((a, b) => {
      if (b.NAME && b.VISIBILITY === STANDARD_GRUNDURVAL_VISIBILITY) {
        a.push({ id: b.id, name: b.NAME });
      }
      return a;
    }, [])
  );
};

export default EkonomiskAnalysGrundurvalQuery;
